import React from 'react';
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Box,
  TextField,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { addDocumentStyle, removeDocumentStyle } from '../constants';
import {
  handleDamageDescriptionChange,
  toggleProtocolFields,
  toggleDamageDescriptionField,
} from '../../../../helperFunctions/its/itsUninstalProtocolHelper';
import { useStyles } from '../../../../helperFunctions/its';
import ItsUninstaledMaterials from '../ItsProtocols/ItsUninstaledMaterials';

export default () => {
  const data = useSelector(state => state.tasks.data);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);

  const dispatch = useDispatch();

  if (!task) return null;

  const itsUninstalProtocol = task ? task.itsUninstalProtocol : null;

  let isProtocolOpen = itsUninstalProtocol && itsUninstalProtocol.open;
  let buttonStyle = isProtocolOpen ? removeDocumentStyle : addDocumentStyle;
  let buttonText = isProtocolOpen
    ? 'Премахни протокол за деинсталация'
    : 'Добави протокол за деинсталация';

  const classes = useStyles();

  return (
    <>
      <Button
        variant="contained"
        style={buttonStyle}
        onClick={() => toggleProtocolFields(dispatch, data, task, itsUninstalProtocol)}
      >
        {buttonText}
      </Button>
      {isProtocolOpen ? (
        <>
          <ItsUninstaledMaterials />
          <FormControl
            style={{ marginTop: '10px', width: '100%', marginBottom: '10vh' }}
            component="fieldset"
            variant="standard"
          >
            <Box marginTop={1}>
              <FormControl className={classes.damageFields}>
                <FormLabel>
                  Има ли нанесени щети върху собственост на клиента при деинсталиране на
                  оборудването:
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={task.itsUninstalProtocol.damageDescriptionField ?? 'no'}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio size="small" />}
                    label="Да. Моля опишете нанесената щета"
                    onClick={() => toggleDamageDescriptionField(dispatch, task, data, true)}
                  />
                  {task.itsUninstalProtocol.damageDescriptionField === 'yes' ? (
                    <TextField
                      multiline
                      variant="filled"
                      label="Описание"
                      value={task.itsUninstalProtocol.damageDescription}
                      onChange={event => handleDamageDescriptionChange(event, dispatch, task, data)}
                    />
                  ) : (
                    <></>
                  )}
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        size="small"
                        onClick={() => toggleDamageDescriptionField(dispatch, task, data, false)}
                      />
                    }
                    label="Не"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </FormControl>
        </>
      ) : null}
    </>
  );
};
